import { doc, getDoc, collection, query, where, getDocs, getFirestore } from 'firebase/firestore';
import firebaseApp from '../../firebase/credenciales';

const db = getFirestore(firebaseApp);

/**
 * Genera el archivo de Pagos Masivos Interbank (Formato Teleproceso - Haberes)
 * @param {string} planillaId - ID de la planilla a exportar
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const generarPagosInterbank = async (planillaId) => {
  try {
    const planillaRef = doc(db, "pl_planillas", planillaId);
    const planillaDoc = await getDoc(planillaRef);
    if (!planillaDoc.exists()) throw new Error("Planilla no encontrada");
    const planilla = planillaDoc.data();

    const detalleQuery = query(
      collection(db, "pl_planilla_detalle"),
      where("planilla_id", "==", planillaId)
    );
    const detalleSnapshot = await getDocs(detalleQuery);
    const detalles = [];
    detalleSnapshot.forEach(doc => detalles.push(doc.data()));

    if (detalles.length === 0) throw new Error("No hay trabajadores en esta planilla");

    const lineas = detalles.map(d => {
      // 1. Tipo de Registro (1 car.) 'D'
      const tipoRegistro = 'D';

      // 2. Tipo de Documento (1 car.) '1' para DNI
      const tipoDoc = '1';

      // 3. Número de Documento (12 car.) completar con espacios a la derecha
      const numDoc = String(d.dni || d.empleado_id || '').substring(0, 12).padEnd(12, ' ');

      // 4. Nombre del Trabajador (40 car.) completar con espacios a la derecha
      const nombreFull = `${d.nombres || ''} ${d.apellidos || ''}`.trim();
      const nombre = nombreFull.substring(0, 40).padEnd(40, ' ');

      // 5. Moneda del Abono (3 car.) '001' para Soles
      const moneda = '001';

      // 6. Monto del Abono (11 car.) 9 enteros y 2 decimales, sin punto ni coma, zero padding
      const montoNum = Number(d.neto_pagar || 0);
      const montoFormateado = (montoNum * 100).toFixed(0).padStart(11, '0');

      // 7. Tipo de Cuenta (1 car.) 'A' para Ahorros
      const tipoCuenta = 'A';

      // 8. Número de Cuenta (20 car.) completar con espacios a la derecha
      const cuenta = String(d.numero_cuenta || '').substring(0, 20).padEnd(20, ' ');

      // 9. Referencia/Concepto (20 car.) completar con espacios a la derecha
      const periodo = planilla.periodo || 'MARZO 2026'; // Fallback por si no viene el periodo
      const referencia = `PLANILLA ${periodo.toUpperCase()}`.substring(0, 20).padEnd(20, ' ');

      return `${tipoRegistro}${tipoDoc}${numDoc}${nombre}${moneda}${montoFormateado}${tipoCuenta}${cuenta}${referencia}`;
    });

    const contenido = lineas.join('\r\n') + '\r\n';
    const nombreArchivo = `INTERBANK_PAGOS_${planilla.periodo || 'MARZO_2026'}.txt`;
    
    descargarArchivo(nombreArchivo, contenido);

    return { 
      success: true, 
      message: `Archivo de pagos Interbank generado exitosamente (${detalles.length} trabajadores)` 
    };
  } catch (error) {
    console.error("Error generando pagos Interbank:", error);
    throw error;
  }
};

const descargarArchivo = (nombre, contenido) => {
  const blob = new Blob([contenido], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
